import React from 'react';

/*
 * CREA-required trademark statement. CREA's DDF display rules require an
 * MLS® / REALTOR® trademark statement on every page that displays MLS®
 * listing content — buyer chat, buyer portal, and the unified portal all
 * qualify. Wording follows CREA's standard trademark statement.
 */
const style = {
  margin: '18px auto 0',
  maxWidth: 640,
  fontSize: 10.5,
  lineHeight: 1.5,
  textAlign: 'center',
  color: 'inherit',
  opacity: 0.6,
};

export default function CreaTrademarkNotice({ className }) {
  return (
    <p className={className} style={className ? undefined : style}>
      REALTOR®, REALTORS®, and the REALTOR® logo are certification marks that are owned by
      REALTOR® Canada Inc. and licensed exclusively to The Canadian Real Estate Association
      (CREA). These certification marks identify real estate professionals who are members of
      CREA and who must abide by CREA&apos;s By-Laws, Rules, and the REALTOR® Code. The MLS®
      trademark and the MLS® logo are owned by CREA and identify the quality of services
      provided by real estate professionals who are members of CREA.
    </p>
  );
}
